import React from "react";
import { styled } from "@styles";
import useOnScreen from "@hooks";

const Wrapper = styled.div`
  display: inline;
`;

interface IProps {
  children: React.ReactNode;
  onVisible: () => void;
}

const VisibilityDetector: React.FC<IProps> = ({
  children,
  onVisible,
}: IProps) => {
  const ref = React.useRef();
  const isVisible = useOnScreen(ref);

  React.useEffect(() => {
    if (isVisible) {
      onVisible();
    }
  }, [isVisible]);

  return <Wrapper className="visibility-detector" ref={ref}>{children}</Wrapper>;
};

export { VisibilityDetector };
